import { render, staticRenderFns } from "./InsertPassword.vue?vue&type=template&id=0a4dcd79&"
import script from "./InsertPassword.vue?vue&type=script&lang=js&"
export * from "./InsertPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports